/* Copyright (c) Trimble Inc. All rights reserved. */
import React from "react";
import ProductDiscovery from "./ProductDiscovery";
import { useProductListController } from "../components/ProductList.controller";
import { Box } from "@material-ui/core";
import { Breadcrumbs } from "modus/components/generic-page-title/Breadcrumbs";

export const ProductPage: React.FC = () => {
  const { asyncResponse } = useProductListController();

  return (
    <Box m={2}>
      <Breadcrumbs pageTitle={"Products"} />
      <ProductDiscovery asyncResponse={asyncResponse} />
    </Box>
  );
};

export default ProductPage;
